var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "TcEventsMyCalendar" }, [
    _c("nav", { staticClass: "tabs my-5" }, [
      _c(
        "span",
        {
          staticClass: "tab",
          on: {
            click: function($event) {
              return _vm.$root.setPage("events-list")
            }
          }
        },
        [_vm._v("Listado")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "tab active" }, [_vm._v("Mis inscripciones")])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-1/2 mx-auto" },
      _vm._l(_vm.my_events, function(event) {
        return _c("TcEventItem", {
          key: event.id,
          staticClass: "mb-3",
          attrs: { event: event, subscribed: true, hide_buttons: true }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }